import { render } from "./pediatrics_notes.vue?vue&type=template&id=6716bbe8&scoped=true"
import script from "./pediatrics_notes.vue?vue&type=script&lang=js"
export * from "./pediatrics_notes.vue?vue&type=script&lang=js"

import "./pediatrics_notes.vue?vue&type=style&index=0&id=6716bbe8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6716bbe8"]])

export default __exports__